
import { useEffect, useRef } from 'react'

export const useLoadOne = ({ loadOne = () => { }, params, onSuccess = () => { }, reloadCounter }) => {
    const onSuccessRef = useRef(onSuccess);
    onSuccessRef.current = onSuccess;

    useEffect(() => {
        if (!params?.id) return;
        loadOne(params.id).then(item => {
            onSuccessRef.current(item);
        });
    }, [reloadCounter, params?.id, loadOne])
}
